import {
  combine,
  withMemo,
  withContext,
  withCallbacks,
  withEffect,
} from 'react-hooks-combine'
import { StoreContext } from 'store/context'
import { ServicesContext } from 'services/context'
import { withTableController } from 'shared/hooks'
import { toaster } from 'utils/toast-wrapper'
import { withRouter } from 'react-router'
import { profile } from 'routes/route.map'

import AccountComponent from './component'
import { createColumns } from './columns.description'

export default combine({
  hocs: [withRouter],
  hooks: [
    withTableController({ id: 'account-movements' }),

    withContext('appStore', StoreContext),

    withContext(
      'paymentService',
      ServicesContext,
      ({ paymentService }) => paymentService
    ),

    withContext(
      'disposableTokensService',
      ServicesContext,
      ({ disposableTokensService }) => disposableTokensService
    ),

    withMemo('columns', () => createColumns(), []),
    withEffect((_store, { history }) => {
      const hash = window.location.hash.substring(1)
      const pairs = hash.split('&')
      const result = pairs.reduce((acum, pair) => {
        const [key, value] = pair.split('=')
        acum[key] = value
        return acum
      }, {})
      switch (true) {
        case !!result.idempotencyKey === true:
          toaster.success('Balance has been updated')
          history.replace(profile.balance())
          break
        case result.idempotencyKey !== undefined &&
          !!result.idempotencyKey === false:
          toaster.info('Payment cancellation')
          history.replace(profile.balance())
          break
        default:
          break
      }
    }, []),
    withCallbacks(
      {
        loadAccountMovements:
          ({ paymentService }) =>
            (tableState) => {
              return paymentService.queryBalanceHistory({
                page: tableState.page || 0,
                size: tableState.pageSize || 20,
              })
            },

        onUserPayment:
          ({ paymentService, disposableTokensService }) =>
            async () => {
              const token = await disposableTokensService.getTempToken()
              await paymentService.requestAddBalance(token)
            },

        onDeleteCard:
          ({ appStore }) =>
            async (cardId) => {
              await appStore.cards.delete(cardId)
            },
      },
      []
    ),
  ],
  transformProps: ({
    appStore,
    columns,
    loadAccountMovements,
    onUserPayment,
  }) => {
    return {
      appStore,
      columns,
      loadAccountMovements,
      onUserPayment,
    }
  },
})(AccountComponent)
